import { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";

import { ApiService } from "../../../config";
import { handleToken } from "../../../utils/expiredTokenLogout";
import { handleError } from "../../../utils/parseApiReturn";
import type { EstadoDeAcesso, PerfilQualidade, QualidadePorEmail } from "../types";

const auth = (token: string): AxiosRequestConfig => ({
  headers: { Authorization: `Bearer ${token}` },
});

const getQualidadePorEmail = async (token: string): Promise<QualidadePorEmail[]> => {
  try {
    const result = await ApiService.get("/profile-quality/by-email", auth(token));
    const { data, error } = result.data;
    if (error) {
      handleToken(result.data.message);
      toast.error(handleError(error, "Erro ao carregar a qualidade dos perfis.").message);
      return [];
    }
    return data ?? [];
  } catch (error) {
    toast.error(handleError(error, "Erro ao carregar a qualidade dos perfis.").message);
    return [];
  }
};

const getPerfis = async (
  token: string,
  filtros: { email?: string; estado?: EstadoDeAcesso },
): Promise<PerfilQualidade[]> => {
  try {
    const result = await ApiService.get("/profile-quality/profiles", {
      ...auth(token),
      params: filtros,
    });
    const { data, error } = result.data;
    if (error) {
      handleToken(result.data.message);
      toast.error(handleError(error, "Erro ao carregar os perfis.").message);
      return [];
    }
    return data ?? [];
  } catch (error) {
    toast.error(handleError(error, "Erro ao carregar os perfis.").message);
    return [];
  }
};

const marcarAcessoSolicitado = async (token: string, publicId: string): Promise<boolean> => {
  try {
    const result = await ApiService.put(
      `/profile-quality/${publicId}/acesso-solicitado`,
      {},
      auth(token),
    );
    if (result.data?.error) {
      toast.error(handleError(result.data.error, "Erro ao marcar o pedido de acesso.").message);
      return false;
    }
    toast.success("Marcado como acesso solicitado.");
    return true;
  } catch (error) {
    toast.error(handleError(error, "Erro ao marcar o pedido de acesso.").message);
    return false;
  }
};

export const profileQualityService = {
  getQualidadePorEmail,
  getPerfis,
  marcarAcessoSolicitado,
};
